// 线上处方
export const columnsToOnline = [
  {
    title: '患者名称',
    dataIndex: 'patientName',
    key: 'patientName'
  },
  {
    title: '诊断',
    dataIndex: 'diagnosisInfoVOList',
    key: 'diagnosisInfoVOList',
    customRender: ({ text }) => {
      const ans = text.map(m => m.diagnosisName).join(',')
      return ans || '--'
    }
  },
  {
    title: '处方ID',
    dataIndex: 'parentSn',
    key: 'parentSn'
  },
  {
    title: '处方类型',
    dataIndex: 'prescriptionTypeList',
    key: 'prescriptionTypeList',
    width: 150,
    customRender: ({ text }) => {
      // const arr = ['西药处方', '中药处方']
      // return arr[text]
      return text.join('，')
    }
  },
  {
    title: '复诊日期',
    dataIndex: 'revisitInfoVO',
    key: 'revisitInfoVO',
    customRender: ({ text, record }) => {
      if (!text) return ''
      const { revisitTime, revisitType } = text
      return `${revisitTime} (${revisitType === 1 ? '线上问诊' : '门诊就诊'})`
    },
    width: 200
  },
  {
    title: '开方时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 150
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    width: 100, // 右侧固定列预留更多宽度
    slots: { customRender: 'handle' },
    fixed: 'right'
  }
]
// AI相关类型的工单类型
// 	PRESCRIPTION_WAIT_BUY(2, "处方待购"),
// 	AI_GUIDE_CONSULT(3, "AI引导问诊小结"),
// 	CHAT_FOLLOWUP_TASK(4,"复诊跟踪"),
// 	CHAT_FOLLOWUP_REMIND(5,"复诊提醒"),
// 	CHAT_PATIENT_PRIVATE(6,"患者私聊"),
// 	CHAT_FOLLOWUP_DATE_DISAGREE(7,"复诊日期未确认"),
// 	CHAT_SUPPLEMENT_MEDICAL(8,"填写诊断及复诊日期")
export const AI_TYPE = [
  { value: 2, title: '处方待购' },
  { value: 3, title: 'AI引导问诊小结' },
  { value: 4, title: '复诊跟踪' },
  { value: 5, title: '复诊提醒' },
  { value: 6, title: '患者私聊' },
  { value: 7, title: '复诊日期未确认' },
  { value: 8, title: '填写诊断及复诊日' },
  { value: 12, title: '疗效跟踪' },
  { value: 13, title: '疗效反馈' }
]
export const AppointColumns = [
  {
    title: '预约编号',
    key: 'reserveSn',
    dataIndex: 'reserveSn',
    width: 120
  },
  {
    title: '医生姓名',
    key: 'doctorName',
    dataIndex: 'doctorName',
    width: 90
  },
  {
    title: '就诊人姓名',
    key: 'patientName',
    dataIndex: 'patientName',
    width: 110
  },
  {
    title: '就诊医院',
    key: 'hospitalName',
    dataIndex: 'hospitalName',
    width: 100
  },
  {
    title: '就诊科室',
    key: 'department',
    dataIndex: 'department',
    width: 100
  },
  {
    title: '预约就诊时间',
    key: 'reserveDate',
    dataIndex: 'reserveDate',
    width: 150,
    slots: {
      customRender: 'reserveDate'
    }
  },
  {
    title: '预约类型',
    key: 'revisitType',
    dataIndex: 'revisitType',
    width: 100,
    slots: {
      customRender: 'revisitType'
    }
  },
  {
    title: '状态',
    key: 'reserveState',
    dataIndex: 'reserveState',
    width: 100,
    slots: {
      customRender: 'reserveState'
    }
  },
  {
    title: '创建时间',
    key: 'createdAt',
    dataIndex: 'createdAt',
    width: 140
  },
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 100,
    slots: {
      customRender: 'operation'
    }
  }
]

export const SOURCE = {
  1: '预问诊',
  2: 'AI生成',
  3: '虚拟电话',
  4: '医助创建'
}
